const packages = {
  zxcvbn: [
    {
      tag: 'SCRIPT',
      attributes: {
        src: window.theme.assets.zxcvbn,
        async: true,
        type: 'text/javascript',
      },
    },
  ],
  loopOnstore: [
    {
      tag: 'SCRIPT',
      attributes: {
        src: window.theme.assets.loopOnstoreSdk,
        async: true,
        type: 'text/javascript',
      },
    },
  ],
};

window.hasLoaded = {
  packages: {},
};

window.isLoading = {
  packages: {},
};

const loadScript = (script) =>
  new Promise((resolve, reject) => {
    const firstScriptTag = document.getElementsByTagName('script')[0];

    script.addEventListener('load', resolve);
    script.addEventListener('error', reject);

    firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
  });

const loadPackage = (name) => {
  if (name in packages === false) Promise.reject(new Error(`Package: '${name}' not found`));

  const scriptsToLoad = packages[name].reverse().map(({ tag, attributes }) => {
    const script = document.createElement(tag);

    Object.keys(attributes).forEach((attributeName) => {
      script.setAttribute(attributeName, attributes[attributeName]);
    });

    return script;
  });

  return Promise.all(scriptsToLoad.map(loadScript));
};

document.addEventListener('package:load', async (e) => {
  const { name } = e.detail;

  window.isLoading.packages[name] = true;

  try {
    await loadPackage(name);

    window.hasLoaded.packages[name] = true;
    window.isLoading.packages[name] = false;

    document.dispatchEvent(new CustomEvent(`package:loaded:${name}`, { cancelable: true }));
  } catch (error) {
    document.dispatchEvent(
      new CustomEvent(`package:failed:${name}`, { cancelable: true, detail: { error } }),
    );
  }
});
